/**
 * Shared helpers for MOCK service functions only. Never imported by real service
 * calls — keeps the "this path is mocked" signal grep-able (`_mockUtils`).
 */

/** Simulates network latency so loading/skeleton states are visible in mock screens. */
export function mockDelay(ms = 220): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Deterministic pseudo-random in [0, 1) — stable across renders/reloads, no time seed. */
export function seeded(index: number, salt = 1): number {
  const x = Math.sin(index * 12.9898 * salt + 78.233) * 43758.5453;
  return x - Math.floor(x);
}

export function pick<T>(arr: readonly T[], index: number, salt = 1): T {
  return arr[Math.floor(seeded(index, salt) * arr.length)];
}

export function range(count: number): number[] {
  return Array.from({ length: count }, (_, i) => i);
}
